<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20 ">
			<div class="title_shaixuan flex_jc_center">综合筛选</div>
			<div>
				<el-form :inline="true" :model="formData" class="demo-form-inline">
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.achievement" placeholder="业绩">
							<el-option v-for="(item, index) in achievement" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.machinery" placeholder="机械">
							<el-option v-for="(item, index) in machinery" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.equipment" placeholder="设备">
							<el-option v-for="(item, index) in equipment" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "teamScreen",
    data() {
      return {
        achievement: [
          { name: "0-10万", no: 0 },
          { name: "10-100万", no: 1 },
          { name: "100-500万", no: 2},
          { name: "500-1000万", no: 3},
          { name: "1000万以上", no: 4}
        ],
        machinery: [
          { name: "自有机械", no: 0 },
          { name: "无自有机械", no: 1 },
        ],
        equipment: [
          { name: "自有设备", no: 0 },
          { name: "无自有设备", no: 1 },
        ],
        formData:{
          achievement:'',
          machinery:'',
          equipment:'',
        }
      }
    },
    watch:{
      'formData.achievement':function (v){
        let obj=this.achievement.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'achievement')
        }
      },
      'formData.machinery':function (v){
        let obj=this.machinery.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'machinery')
        }
      },
      'formData.equipment':function (v){
        let obj=this.equipment.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'equipment')
        }
      },
    },
    methods: {
      /** @name 搜索单项 */
      send(obj,key){
        if(key)obj.key=key;
        //替换搜索项
        let type=-1;
        this.$parent.$refs.screen.teamScreen.map((d,i)=>{
          if(d.key==key){
            type=i
          }
        });
        if(type>-1) {
          this.$parent.$refs.screen.teamScreen.splice(type,1,obj)
          return
        }
        //添加搜索项
        this.$parent.$refs.screen.teamScreen.push(obj)
      },
      /** @name 清队单项 */
      close(item){
        this.formData[item.key]=''
      },
      /** @name 清空所有 */
      closeall(){
        this.formData={
          achievement:'',
          machinery:'',
          equipment:'',
        }
      }
    },
	}
</script>

<style scoped>

</style>
